export default __webpack_public_path__ + "static/Jacobs-COVID19-Risk-Assessment-v1.3-04.01.21-2-c6beb70d4870b9190b464cf4a4eab37b.pdf";